export enum CdnDashboardTab {
  TRAFFIC = 'TRAFFIC',
  LOG = 'LOG',
  ATTACK_LOG = 'ATTACK_LOG',
  ERROR_LOG = 'ERROR_LOG',
  WAF_LOG = 'WAF_LOG',
}
